import {
  ContainerErrorType,
  ICriticalContainerError,
  IErrorBase,
  IGenericError,
  IThrottlingWarning,
} from '@fluidframework/container-definitions';

/** Specifies whether the given `error` is a throttling error from Fluid server. */
export function isFluidThrottlingError(error: IErrorBase): error is IThrottlingWarning {
  return error.errorType === ContainerErrorType.throttlingError;
}

/**
 * Specifies whether the given `error` is a generic Fluid error. "most likely an exception, propagated as critical
 * container error" ref: @fluidframework\container-definitions\src\error.ts
 */
export function isFluidGenericError(error: IErrorBase): error is IGenericError {
  return error.errorType === ContainerErrorType.genericError;
}

/** Specifies whether the given `error` is a data corruption or data processing error from Fluid server. */
export function isFluidRuntimeError(error: IErrorBase): error is ICriticalContainerError {
  return (
    error.errorType === ContainerErrorType.dataCorruptionError ||
    error.errorType === ContainerErrorType.dataProcessingError
  );
}
